export default __webpack_public_path__ + "static/media/abra.b96ae174.gif";